import {CookiesProvider} from 'react-cookie';
import {Navigate, Route, Routes} from 'react-router-dom';

import AdminLayout from './components/layout/AdminLayout';
import UserAppLayout from './components/layout/UserAppLayout';
import {AuthContextProvider} from './context/AuthContext';
import AdminRoutes from './routes/AdminRoutes';
import AuthRoutes from './routes/AuthRoutes';
import UserRoutes from './routes/UserRoutes';

export default function App() {
    return (
        <AuthContextProvider>
            <CookiesProvider>
                <Routes>
                    <Route element={<UserAppLayout />}>
                        <Route path='/' element={<Navigate to='/chat' replace />} />
                        <Route path='/chat/*' element={<UserRoutes />}/>
                    </Route>
                    <Route element={<AdminLayout />}>
                        <Route path='/admin/*' element={<AdminRoutes />} />
                    </Route>
                    <Route path='/auth/*' element={<AuthRoutes />} />
                </Routes>
            </CookiesProvider>
        </AuthContextProvider>
    );
}
